/** Query param of the card detail that names the movement open in its detail drawer. */
export const CARD_MOVEMENT_PARAM = "movement";

/**
 * The card detail on its Movements tab with one movement open. Any link to a card movement goes through here
 * — the corner alerts and the drawer's "copy link" — so they all land on the same screen.
 */
export const cardMovementPath = (cardId: string, movementId: string): string =>
  `/app/cards/cards/${cardId}?tab=transactions&${CARD_MOVEMENT_PARAM}=${encodeURIComponent(movementId)}`;
